<template><span class="condition"><template v-for="(part, i) in parts" :key="i"><span v-if="part.kind === 'value'" class="condition-value">{{ part.text }}<small v-if="part.code" class="condition-code">{{ part.code }}</small><small v-if="part.missing" class="condition-missing">未设中文名称</small></span><span v-else :class="part.kind && `condition-${part.kind}`">{{ part.text }}</span></template></span></template>
<script setup>
/* global defineProps */
// 流程条件文字：字段名称上色加下划线；卡片代码的值为实心标签（代码以小灰字给工程师对照），访客输入的说法为虚线框标签
import { computed } from 'vue'
import { conditionParts } from './workflow-presentation'
const props = defineProps({ condition: { type: Object, default: null }, slots: { type: Object, default: () => ({}) } })
const parts = computed(() => conditionParts(props.condition, props.slots))
</script>
<style scoped>
.condition-field { color: #047857; text-decoration: underline; text-underline-offset: 3px; }
.condition-value, .condition-phrase { display: inline-block; margin: 1px 2px; padding: 0 7px; border-radius: 10px; line-height: 1.6; font-weight: normal; }
.condition-value { background: #fff7ed; border: 1px solid #fed7aa; color: #b45309; }
.condition-code { margin-left: 5px; color: #94a3b8; font-family: monospace; font-size: .8em; }
.condition-phrase-label { margin: 0 2px 0 8px; color: #64748b; font-size: .85em; font-weight: normal; }
.condition-phrase { border: 1px dashed #cbd5e1; color: #475569; }
.condition-missing { margin-left: 5px; color: #dc2626; font-size: .75em; }
</style>
